import _ from 'lodash';
import moment from 'moment';

/**
 * true // console enable
 * false // console disable
 */
export const isDebug = () => process.env.REACT_APP_USE_DEBUG_CONSOLE === "true" ? true : false;

/** ****************************
 * 상수
 ***************************** */
export const divName = {
  conFirmDivName: 'confirm-alert',
  alertDivName: 'alert',
  loadingDivName: 'loading',
};

export const alertType = {
  Error: 'error',
  Warning: 'warning',
  Info: 'info',
  Success: 'success',
};

export const validationType = {
  string: 'string',
  number: 'number',
  email: 'email',
  phone: 'phone',
  require: '',
};

export const utils = {
  regex: {
    number: /^\d/g,
    email: /^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*@[-A-Za-z0-9_]+[-A-Za-z0-9_.]*\.[A-Za-z]{1,5}$/,
    phone: /^\d{2,3}\d{3,4}\d{4}$/,
    phoneWithHyphen: /^\d{2,3}-\d{3,4}-\d{4}$/,
  },
  date: {
    /**
     * 형변환 날짜 > 문자열
     * @param date typeof date
     * @param format yyyy-mm-dd..
     * @returns {string}
     */
    dateToString: (date, format = 'YYYY-MM-DD') => moment(date).format(format.toUpperCase()),
    getYearMonth: () => {
      let dte = new Date();
      let year = dte.getFullYear();
      let month = dte.getMonth() + 1;
      month = month < 10 ? `0${month}` : month;
      return `${year}-${month}`;
    },
    getDate: (stringspliter = '-') => {
      let todaye = new Date();
      let year = todaye.getFullYear();
      let month = todaye.getMonth() + 1;
      let date = todaye.getDate();
      month = month < 10 ? `0${month}` : month;
      date = date < 10 ? `0${date}` : date;
      return `${year}${stringspliter}${month}${stringspliter}${date}`;
    },
    getEndDate: (stringDate) => {
      let v = stringDate.split('-');
      let endDate = new Date(parseInt(v[0]), parseInt(v[1]), 1); 
      return (endDate.getDate() - 1); // 달의 1일날 이전 날 확인
    },
    getString2Date: (stringDate) => {
      let v = stringDate.split('-');
      return new Date(parseInt(v[0]), parseInt(v[1]) - 1, parseInt(v[2]));
    },
    getString2Day: (stringDate) => utils.date.getString2Date(stringDate).getDay(),
    getInteger2Date: (year, month, date) => new Date(year, month, date),
    getInteger2Day: (year, month, date) => utils.date.getInteger2Date(year, month, date).getDay(),
  },
  string: {
    /**
     * 좌측 문자열 채우기
     * @param val 채울값
     * @param len 채울 길이
     * @returns {string}
     */
    lPad: (val, len) => {
      const str = val.toString();
      let i = 0;
      let ret = '';
      while (i++ < (len - str.length)) {
        ret += '0';
      }
      return ret + str;
    },
    /**
     * 형변환 문자 > 날짜
     * @param s
     * @param format
     * @returns {Date}
     */
    stringToDate: (s, format) => moment(s, format).toDate(),
  },
  number: {
    /**
     * 형변환 숫자 > 문자
     * @param val
     * @param len
     * @returns {string}
     */
    nPad: (val, len) => {
      const str = val.toString();
      let i = 0;
      let ret = '';
      while (i++ < (len - str.length)) {
        ret += '0';
      }
      return ret + str;
    },
    /**
     * 형변환 문자 > 숫자
     * @param s
     * @returns {number}
     */
    stringToNumber: (s) => {
      if (s === null || s === undefined) return 0;
      const num = Number(s.replace(/,/g, ''));
      return isNaN(num) ? 0 : num;
    },
    numberToStringFormat: (n) => {
      if (n === null || n === undefined) return 0;
      return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
  },
  api: {
    getNameFromArray: (arr, key) => (arr.filter((it) => it.key === key))[0].name,
    getNameFromArray2: (arr, key) => {
      const ret = arr.filter((it) => it.key === key);
      if (ret.length > 0) return ret[0].name;
      return null;
    },
    decodeJWT: (token) => {
      try {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split("")
            .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
            .join("")
        );
        return JSON.parse(jsonPayload);
      } catch (error) {
        if (isDebug()) console.error("Invalid token:", error);
        return null;
      }
    },
    getToken: () => {
      const token = utils.web.localStorageLoad('TOKEN');
      if (token) {
        const decoded = utils.api.decodeJWT(token);
        if (decoded) {
          return decoded;
        }
      }
      return null;
    },
    /**
     * window.location.hostname;   // => aaaa.local
     * window.location.href;       // => http://aaaa.local:8088/test.jsp
     * window.location.host;       // => aaaa.local:8088
     * window.location.port;       // => 8088
     * window.location.pathname;   // => test.jsp
     * window.location.search;     // => ?gg=1
     * window.location.protocol;   // => http:
     */
    getCurrentURL: (def = 'about') => {
      const url = window.location.pathname === '/' ? def : window.location.pathname.substring(1, window.location.pathname.length);
      if (url.indexOf('/')) {
        const p = url.split('/');
        return p[0];
      }
      return url;
    },
    getCurrentPath: () => {
      const path = window.location.pathname;
      return path.substring(path.lastIndexOf('/') + 1);
    },
    getCurrentMenu: () => {
      if (window.location.pathname === '/') return null;
      return _.filter(JSON.parse(utils.web.localStorageLoad('MENU')), { RMS: window.location.pathname });
    },
    getHeader: (p) => {
      const header = new Headers({
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
        'X-API-Key': '123',
      });
      return header;
    },
    fetchPost: (url, params, callback) => {
      const requestOptions = {
        method: 'POST',
        headers: utils.api.getHeader(params),
        body: JSON.stringify(params),
        // mode:"no-cors"
      };
      fetch(url, requestOptions).then((response) => response.json()).then((data) => callback(data, null)).catch((error) => callback(null, error));
    },
    fetchGet: (url, params, callback) => {
      const requestOptions = {
        method: 'GET',
        headers: utils.api.getHeader(params),
        // mode:"no-cors"
      };
      fetch(url, requestOptions).then((response) => response.json()).then((data) => callback(data, null)).catch((error) => callback(null, error));
    },
    stringifyComponent: (Comp) => {
      try {
        return JSON.stringify(Comp);
      } catch (err) {
        return String(Comp);
      }
    },
    parseComponent: (str) => {
      try {
        return JSON.parse(str);
      } catch (err) {
        return str;
      }
    },
  },
  web: {
    localStorageSave: (name, value) => {
      try {
        if (typeof (localStorage) === 'undefined') { alert('localStorage 를 지원합니다'); return; }
        localStorage.setItem(name, value);
      } catch (e) {
        alert(e.ErrorMessage);
      }
    },
    localStorageLoad: (name) => {
      try {
        if (typeof (localStorage) === 'undefined') { alert('localStorage 를 지원합니다'); return; }
        // eslint-disable-next-line consistent-return
        return localStorage.getItem(name);
      } catch (e) {
        // eslint-disable-next-line consistent-return
        return e.ErrorMessage;
      }
    },
    localStorageRemove: (name) => {
      try {
        if (typeof (localStorage) === 'undefined') { alert('localStorage 를 지원합니다'); return; }
        localStorage.removeItem(name);
      } catch (e) {
        alert(e.ErrorMessage);
      }
    },
    sessionStorageSave: (name, value) => {
      try {
        if (typeof (sessionStorage) === 'undefined') { alert('sessionStorage 를 지원합니다'); return; }
        sessionStorage.setItem(name, value);
      } catch (e) {
        alert(e.ErrorMessage);
      }
    },
    sessionStorageLoad: (name) => { 
      try {
        if (typeof (sessionStorage) === 'undefined') { alert('sessionStorage 를 지원합니다'); return; }
        // eslint-disable-next-line consistent-return
        return sessionStorage.getItem(name);
      } catch (e) {
        // eslint-disable-next-line consistent-return
        return e.ErrorMessage;
      }
    },
    sessionStorageRemove: (name) => {
      try {
        if (typeof (sessionStorage) === 'undefined') { alert('sessionStorage 를 지원합니다'); return; }
        sessionStorage.removeItem(name);
      } catch (e) {
        alert(e.ErrorMessage);
      }
    },
    setCookie: (name, value, days = 7) => {
      const expires = new Date();
      expires.setDate(expires.getDate() + days);
      document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/`;
    },
    getCookie: (name) => {
      const cname = `${name}=`;
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(cname) === 0) {
          return c.substring(cname.length, c.length);
        }
      }
      return '';
    },
    deleteCookie: (name) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
    },
    getBrowser: () => {
      const userAgent = navigator.userAgent;
      if (userAgent.indexOf('Chrome') > -1) return 'Chrome';
      if (userAgent.indexOf('Firefox') > -1) return 'Firefox';
      if (userAgent.indexOf('Safari') > -1) return 'Safari';
      if (userAgent.indexOf('MSIE') > -1 || userAgent.indexOf('Trident') > -1) return 'IE';
      return 'Unknown';
    },
    getOS: () => {
      const userAgent = navigator.userAgent;
      if (userAgent.indexOf('Windows NT 10.0') > -1) return 'Windows 10';
      if (userAgent.indexOf('Windows NT 6.3') > -1) return 'Windows 8.1';
      if (userAgent.indexOf('Windows NT 6.2') > -1) return 'Windows 8';
      if (userAgent.indexOf('Windows NT 6.1') > -1) return 'Windows 7';
      if (userAgent.indexOf('Mac OS X') > -1) return 'Mac OS X';
      if (userAgent.indexOf('Linux') > -1) return 'Linux';
      return 'Unknown OS';
    },
    getDevice: () => {
      const userAgent = navigator.userAgent;
      if (userAgent.indexOf('Mobile') > -1) return 'Mobile';
      if (userAgent.indexOf('Tablet') > -1) return 'Tablet';
      return 'Desktop';
    },
    getBrowserVersion: () => {
      const userAgent = navigator.userAgent;
      const match = userAgent.match(/(Chrome|Firefox|Safari|MSIE|Trident)\/?\s*(\d+)/);
      if (match) {
        return match[1] + ' ' + match[2];
      }
      return 'Unknown Version';
    },
    getOSVersion: () => {
      const userAgent = navigator.userAgent;
      const match = userAgent.match(/(Windows NT|Mac OS X|Linux)\s*([\d._]+)/);
      if (match) {
        return match[1] + ' ' + match[2].replace(/_/g, '.');
      }
      return 'Unknown Version';
    },
    getDeviceType: () => {
      const userAgent = navigator.userAgent;
      if (userAgent.match(/iPhone/i) || userAgent.match(/iPad/i) || userAgent.match(/Android/i)) {
        return 'Mobile';
      } else if (userAgent.match(/Windows/i) || userAgent.match(/Macintosh/i)) {
        return 'Desktop';
      } else {
        return 'Unknown Device Type';
      }
    },
    getDeviceInfo: () => {
      const userAgent = navigator.userAgent;
      const deviceType = utils.web.getDeviceType();
      const browser = utils.web.getBrowser();
      const os = utils.web.getOS();
      const osVersion = utils.web.getOSVersion();
      const browserVersion = utils.web.getBrowserVersion();
      return {
        deviceType,
        browser,
        os,
        osVersion,
        browserVersion,
        userAgent,
      };
    },
    getDeviceInfoString: () => {
      const deviceInfo = utils.web.getDeviceInfo();
      return `Device Type: ${deviceInfo.deviceType}, Browser: ${deviceInfo.browser}, OS: ${deviceInfo.os}, OS Version: ${deviceInfo.osVersion}, Browser Version: ${deviceInfo.browserVersion}`;
    },
    setCssVariable: (name, value) => {
      if (document.documentElement) {
        document.documentElement.style.setProperty(name, value);
      }
    }
  },
  routes: {
    getPath: (path) => {
      const pathArray = path.split('/');
      return pathArray[pathArray.length - 1];
    },
    getPath2: (path) => {
      const pathArray = path.split('/');
      return pathArray[pathArray.length - 2];
    },
    getPath3: (path) => {
      const pathArray = path.split('/');
      return pathArray[pathArray.length - 3];
    },
    /**
     * Combine paths
     *
     * @param {string} parent
     * @param {string} child
     * @returns {string}
     */
    combinePaths: (parent, child) => `${parent.replace(/\/$/, '')}/${child.replace(/^\//, '')}`,
    /**
     * Recursively build paths for each navigation item
     *
     * @param routes
     * @param {string} parentPath
     * @returns {*}
     */
    buildPaths: (routes, parentPath = '') => routes.map((route) => {
      const path = utils.routes.combinePaths(parentPath, route.path);
      return {
        ...route,
        path,
        ...(route.routes && { routes: utils.routes.buildPaths(route.routes, path) }),
      };
    }),
    /**
     * Recursively provide parent reference for each navigation item
     *
     * @param routes
     * @param parentRoute
     * @returns {*}
     */
    setupParents: (routes, parentRoute = null) => routes.map((route) => {
      const withParent = {
        ...route,
        ...(parentRoute && { parent: parentRoute }),
      };
      return {
        ...withParent,
        ...(withParent.routes && {
          routes: utils.routes.setupParents(withParent.routes, withParent),
        }),
      };
    }),
    /**
     * Convert navigation tree into flat array
     *
     * @param routes
     * @returns {any[]}
     */
    flattenRoutes: (routes) => routes.map((route) => [route.routes ? utils.routes.flattenRoutes(route.routes) : [], route]).flat(Infinity),
    /**
     * Combine all the above functions together
     *
     * @param routes
     * @returns {any[]}
     */
    generateAppRoutes: (routes) => utils.routes.flattenRoutes(utils.routes.setupParents(utils.routes.buildPaths(routes))),
  },
  page: {
    toggleFullScreen: () => {
      let ret = false;
      try {
        if (!document.fullscreenElement) {
          document.documentElement.requestFullscreen();
          ret = true;
        } else if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      } catch(e) {}
      return ret;
    },
    paginate: (totalCount, pageSize, pageCurrent, displaypagesize = pageSize) => {
      const pageCount = Math.ceil(totalCount / pageSize);
      if (pageCount === 1) return null;
      const pages = _.range(1, pageCount + 1);
      const startIndex = (pageCurrent - 1) * pageSize;
      return {
        totalCount: totalCount,
        pageSize: pageSize,
        page: pageCurrent,
        itemss: _(pages).slice(startIndex).take(displaypagesize).value(),
      };
    },
    setPageCurrent: () => {
      const menuTabs = utils.web.localStorageLoad('MENUTABS') ? JSON.parse(utils.web.localStorageLoad('MENUTABS')) : [];
      let currentMenu = null;
      if (utils.api.getCurrentMenu()) currentMenu = utils.api.getCurrentMenu()[0];
      if(isDebug()) console.log('currentMenu', currentMenu);
      if (currentMenu) {
        const isNew = !menuTabs.some((element) => element.RMS === currentMenu.RMS);
        if (isNew) {
          if (menuTabs.length === 10) menuTabs.shift();
          menuTabs.push(currentMenu);
          utils.web.localStorageSave('MENUTABS', JSON.stringify(menuTabs));
        }
        if(isDebug()) console.log('navigation -> Page -> PageBody Current Menu :', menuTabs);
      }
    },
    getNameValue: (eventTarget, name = '') => {
      const ret = { name: '', value: '', type: '' };
      if (name && name.length > 0) {
        ret.name = name;
      } else {
        ret.name = eventTarget.name ? eventTarget.name : eventTarget.id;
      }
      ret.type = eventTarget.type;
      ret.value = eventTarget.value ? eventTarget.value : '';
      return ret;
    },
      /**
       * Provides path from root to the element
       *
       * @param route
       * @returns {any[]}
       */
      pathTo: (route) => {
        if (!route.parent) {
          return [route];
        }
        return [...utils.page.pathTo(route.parent), route];
      },
      getPath: (route) => utils.page.pathTo(route).map((r) => r.path).join('/').replace(/\/+/g, '/').replace(/^\//, ''),
  },
  etc: {
    sleep: (ms) => new Promise((resolve) => setTimeout(resolve, ms)),
    getRandom: (min, max) => Math.floor(Math.random() * (max - min + 1)) + min,
    getRandomString: (length) => {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return result;
    },
    getRandomStringWithSpecial: (length) => {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+[]{}|;:,.<>?';
      let result = '';
      for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return result;
    },
    getRandomStringWithSpecial2: (length) => {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+[]{}|;:,.<>?';
      let result = '';
      for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return result.replace(/[^a-zA-Z0-9]/g, '');
    },
    copyToClipboard: async(text) => {
      try {
        await navigator.clipboard.writeText(text);
        // console.log('Text copied to clipboard:', text);
      }
      catch (err) {
        if (isDebug()) console.error('Failed to copy: ', err);
      }
    },
  },
};
